module.exports = __webpack_public_path__ + "img/Centro-Picasso-120x55.49152636.png";